module.exports = __webpack_public_path__ + "img/pullnew-bg.3e5e7e23.png";